import GlobalStyle from './theme/globalStyle'
import Home from './pages/Home'

function App() {
  return (
    <>
      <GlobalStyle />
      <Home />
    </>
  )
}

export default App
